import { SimpleLanguage, Environment } from '../enum';

interface BaseConfigItems {
  kahootUrl: string;
}

const baseConfigItems: BaseConfigItems = {
  kahootUrl: 'https://kahoot.it',
};

interface LanguageConfigItems {
  privacyPoliceExtole: string;
  platformTourVideoId: string;
}

const languageConfigItems: Record<SimpleLanguage, LanguageConfigItems> = {
  [SimpleLanguage.en]: {
    privacyPoliceExtole:
      'https://share.openenglish.com/zone/terms?journey.campaign_id=7243822418753585417',
    platformTourVideoId: '85nTCz30UGs',
  },
  [SimpleLanguage.es]: {
    privacyPoliceExtole:
      'https://share.openenglish.com/zone/terms?journey.campaign_id=7243822418753585417',
    platformTourVideoId: '85nTCz30UGs',
  },
  [SimpleLanguage.pt]: {
    privacyPoliceExtole:
      'https://share.openenglish.com/zone/terms?journey.campaign_id=7243822276565721217',
    platformTourVideoId: '8Y40IeK3tRQ',
  },
};

interface EnvironmentConfigItems {
  assetsBucket: string;
}

const environmentConfigItems: Record<Environment, EnvironmentConfigItems> = {
  [Environment.local]: {
    assetsBucket: 'https://junior-static.stg.openenglish.com',
  },
  [Environment.stg]: {
    assetsBucket: 'https://junior-static.stg.openenglish.com',
  },
  [Environment.prod]: {
    assetsBucket: 'https://junior-static.openenglish.com',
  },
};

interface ConfigItems extends BaseConfigItems, LanguageConfigItems, EnvironmentConfigItems {}

export function getConfigs(env: Environment, lang: SimpleLanguage): ConfigItems {
  return {
    ...baseConfigItems,
    ...languageConfigItems[lang],
    ...environmentConfigItems[env],
  };
}
